import { FC, useState } from 'react';
import { Label, SingleDatePicker, Input, P, useTheme } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import moment, { Moment } from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const StyledDateGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  grid-gap: 1rem;
  align-items: center;
`;

const StyledValidationMessage = styled.div`
  padding-top: 1rem;
  svg {
    margin-right: 1rem;
  }
`;

export interface IDateTimePickerProps {
  time: Moment | null;
  onChange: (time: Moment) => void;
  label: string;
  dateAriaLabel?: string;
  datePlaceholder?: string;
  timeAriaLabel?: string;
  focusedDate?: boolean;
  minTime?: string;
  maxTime?: string;
  timezone: string;
  validationMessage?: string;
}

const DateTimePicker: FC<IDateTimePickerProps> = props => {
  const theme = useTheme();

  const [focusedDate, setFocusedDate] = useState(false);
  const timeOffset = (props.time || moment().tz(props.timezone)).format('Z').replace(':00', '');

  const onChangeDate = (date: Moment) => {
    props.onChange(date);
  };

  const onChangeTime = (time: string) => {
    props.onChange(moment.tz(`${props.time.format('YYYY-MM-DD')}T${time}`, props.timezone));
  };
  return (
    <div>
      <Label name={props.label} marginBottom={true} />
      <StyledDateGrid>
        <div>
          <SingleDatePicker
            ariaLabel={props.dateAriaLabel}
            date={props.time}
            onDateChange={(date: Moment) => onChangeDate(date)}
            focused={props.focusedDate || focusedDate}
            onFocusChange={({ focused }) => setFocusedDate(focused)}
            spacingBelow={false}
            placeholder={props.datePlaceholder}
            isFutureDatesOnly={true}
          />
        </div>
        {props.time && (
          <div>
            <Input
              ariaLabel={props.timeAriaLabel}
              type="time"
              spacingBelow={false}
              value={props.time.format('HH:mm')}
              onChange={time => onChangeTime(time)}
              required={true}
              min={props.minTime}
              max={props.maxTime}
            />
          </div>
        )}
        <small>GMT {timeOffset}</small>
      </StyledDateGrid>
      {props.validationMessage && (
        <StyledValidationMessage>
          <P color={theme.vars.newColor.orange2}>
            <FontAwesomeIcon icon={faExclamationTriangle as IconProp} />
            {props.validationMessage}
          </P>
        </StyledValidationMessage>
      )}
    </div>
  );
};

export default DateTimePicker;
